import { format, parseISO } from 'date-fns';

export function formatDate(date: string) {
  return format(parseISO(date), 'dd/MM/yyyy');
}

/**
 * Remove leading zeros for API calls (e.g. 01049924 → 1049924, 00370988 → 370988).
 * Keeps at least one digit if input is only zeros.
 */
export function stripLeadingZerosForApi(
  value: string | number | undefined,
): string | undefined {
  if (value == null || value === '') return undefined;
  const s = String(value).trim();
  const stripped = s.replace(/^0+/, '');
  return stripped === '' ? '0' : stripped;
}
